import { ArrowUpOutlined, DeleteOutlined, DislikeFilled, DislikeOutlined, EditOutlined, EllipsisOutlined, EyeOutlined, GlobalOutlined, HeartOutlined, LikeFilled, LikeOutlined, LockOutlined, QuestionCircleOutlined, SaveOutlined, SettingOutlined, ShareAltOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Card, Col, Menu, MenuProps, Pagination, PaginationProps, Row, Statistic, Typography, Image, Flex, Tooltip, Badge, Result, Button, Popconfirm, message, Tag, notification, Popover, Checkbox, Skeleton } from 'antd'
import styles from './SmallComponents.module.css'
import React, { ReactNode, useEffect, useState } from 'react'
import Meta from 'antd/es/card/Meta'
import SaveIcon from '../../Icons/save.png'
import SaveIconFilled from '../../Icons/savefilled.png'
import ViewIcon from '../../Icons/view.png'
import Title from 'antd/es/typography/Title'
import { useDispatch } from 'react-redux'
// import { fetchUserItems } from '../Slices/UserItemsSlice'
// import { changeCreateSuccess } from '../Slices/CreateCollectionSlice'
// import { changeEditSuccess } from '../Slices/EditCollectionSlice'
// import { fetchUserCollections } from '../Slices/UserCollectionsSlice'
import { useSelector } from 'react-redux'
import { ExceptionStatusType, ResultStatusType } from 'antd/es/result'
// import { changeDeleteSuccess, deleteUserCollection } from '../Slices/DeleteCollectionSlice'
// import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { match } from 'assert'
import { addBookmark, handleDislike, handleLike, setUserInteractionProcessing } from '../../Slices/UserActions'
import { refreshCard, removeBookmarkLocal, updateBookmarkLocal } from '../../Slices/PublicCollectionsDataSlice'
import LoginModal from '../LoginModal/LoginModal'
import BadgeIcon from '../BadgeIcon/BadgeIcon'
import { setAdditionalKeys } from '../../Slices/PublicPageDataSlice'
import { Link, useNavigate } from 'react-router-dom'
import { setWindowNHQ } from '../../Slices/WindowNHQSlice'
// import { refreshAuthorCollections } from '../../Slices/AuthorCollectionsSlice'
import parse from 'html-react-parser'
const { Paragraph, Text } = Typography;




type Props = {
    title: any,
    value: any,
    bg: any,
    valueColor: any,
    suffix: any,
    xs: any,
    sm: any,
    md: any,
    lg: any,
    xl: any,
    xxl: any,
    description:any,
    date:any,
    avatar:any,
    name:any,
    items:any,
    pagination:any,
    defaultActiveKey:any,
    activeKey:any,
    onChange:any,
    onClick:any,
    data:any,
    loading:any,
    isAvailable:any,
    notifyUs?:any,
    featured?:any,
    dataLength?:any
}

function parseHTML(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

// const StatisticCard:any = (props: Props) => {
//     const {title, value, bg, valueColor, suffix, xs, sm, md, lg, xl, xxl} = props;
//   return (
//     <>
//     <Col  xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}  >
//               <Card hoverable className={styles.statsCard} style={{backgroundColor: bg,}} bordered={false}>
//                 <Statistic
//                 className={styles.statisticComponent}
//                 title={title}
//                 value={value}
//                 // precision={}
//                 valueStyle={{ color: valueColor, fontWeight: "bolder", fontSize: "50px", display: "flex", justifyContent: "space-between" }}
//                 // prefix={<ArrowUpOutlined />}
//                 suffix={suffix}
//                 />
//               </Card>
//             </Col>
//     </>
//   )
// }

// const TopCollectionsCard:any = (props: Props) =>{
//   const {xs, sm, md, lg, xl, xxl} = props;

//   return(
//     <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
//     <Card
//     hoverable
//     style={{ width: "100%" }}
//     cover={
//       <img
//         alt="example"
//         src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
//       />
//     }
//     // actions={[
//     //   <SettingOutlined key="setting" />,
//     //   <EditOutlined key="edit" />,
//     //   <EllipsisOutlined key="ellipsis" />,
//     // ]}
//   >
//     <Meta
//       // avatar={<Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />}
//       title="Card title"
//       description="This is the description"
//     />
//   </Card>
//   </Col>
//   )
// }

// const TopContributionsCard:any = (props: Props) =>{
//   const { title, description, date, avatar, name, xs, sm, md, lg, xl, xxl  } = props;
//       return (
//         <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl} >
//           <Card
//           hoverable
//     style={{ width: "100%" }}

//     // actions={[
//     //   <SettingOutlined key="setting" />,
//     //   <EditOutlined key="edit" />,
//     //   <EllipsisOutlined key="ellipsis" />,
//     // ]}
//   >
//     <Meta
//       avatar={<Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />}
//       title={<Title style={{margin: "0", fontSize: "12px"}} level={5}>{title}</Title>}
//       description={description}
//       // style={{border: "2px solid red"}}
//     />
//   </Card>
//         </Col>
//       );
//     };
 
// const Tabs:any = (props: Props) =>{

//     const dispatch = useDispatch<any>();
//       const {items, defaultActiveKey, activeKey, onClick} = props;
    
//       // const onClick: MenuProps['onClick'] = (e:any) => {
//       //   console.log('click ', e);
//       //   dispatch(setStatus(e.key !== 'all' && e.key))
//       //   dispatch(fetchUserCollections());
//       // };
      
//       return(
//         <Menu style={{border: "none", }} defaultValue={defaultActiveKey} onClick={onClick} defaultActiveFirst activeKey={activeKey}  mode="horizontal" items={items} />
//         // <Tabs defaultActiveKey="all" items={items} onChange={onclick} />
//       )
//     }

// const PaginationBar:any = (props: Props) =>{

//   const {pagination} = props;

//   const dispatch = useDispatch<any>();
//   // const current = useSelector((state:any)=> state.UserCollections.page)
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [currentPage, setCurrentPage] = useState<any>(searchParams.get('page') ?? 1);

//   const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
//     if (type === 'prev') {
//       return <a>Prev</a>;
//     }
//     if (type === 'next') {
//       return <a>Next</a>;
//     }
//     return originalElement;
//   };

//   useEffect(()=>{
//     setCurrentPage(searchParams.get('page') ?? 1)
//   }, [searchParams])
  
//   const onChange: PaginationProps['onChange'] = (page:any) => {
//       searchParams.set('page', page)
//       setSearchParams(searchParams)
//       dispatch(fetchUserCollections({page : searchParams.get('page'), status: searchParams.get('status'), search : searchParams.get('search') }));
//   };

  
//     return (
//       <Pagination responsive={true} defaultCurrent={1} current={parseInt(currentPage)} onChange={onChange} total={pagination?.total_posts} itemRender={window.innerWidth < 576 ? undefined : itemRender} />
//     )
// }

const ErrorPage = (props: any) => {
  const {status, title, subTitle, button, messageError, notifyUs, buttonText}= props;
  const [errorTitle, setErrorTitle] = useState("404");
  const [errorSubtitle, setErrorSubtitle] = useState<ReactNode>("404");
   const [errorStatus, setErrorStatus] = useState<ExceptionStatusType | ResultStatusType> (404)
   const navigate = useNavigate();

   useEffect(()=>{

    if(499 < status && status < 600){
    setErrorStatus(500)
    setErrorTitle("An Internal Server Error Occurred");
    setErrorSubtitle("An Internal Server Error Occurred")
  }
  else if (status === 403){
    setErrorStatus(403)
    setErrorTitle("Sorry, you are not authorized to access this page.");
    setErrorSubtitle("Sorry, you are not authorized to access this page.");
  }

  else if (399 < status && status < 499){
    setErrorStatus(403)
    setErrorTitle("Sorry, the page you visited does not exist.");
    setErrorSubtitle("Sorry, the page you visited does not exist.");
  }

  else if ( status === "noresults"){
    setErrorStatus(404)
    setErrorTitle("No Results Found!");
    setErrorSubtitle("Sorry, the page you visited does not exist.");
  }
  else if (status === "collectionNotFound"){
    setErrorStatus(404)
    setErrorTitle("Collection Not Found!")
    setErrorSubtitle(<>It seems the collection you are looking for does not exist.<br /> Please check the URL or browse our other collections.</>)
  }
  else if (status === "authorNotFound"){
    setErrorStatus(404)
    setErrorTitle("Author Not Found!")
    setErrorSubtitle(<>It seems the author profile you are looking for does not exist.<br /> Please check the URL or explore other authors.</>)
  }
  else {
    setErrorStatus('warning')
    setErrorTitle("Unknown Error Occured");
    setErrorSubtitle("Unknown Error Occured");
  }
  
}, [status])

  
  return (
      !status ? <></> :
<Result
  status={errorStatus}
  title={errorTitle}
  subTitle={subTitle ? errorSubtitle : false}
  extra={button ? <><Button type="primary" onClick={()=>
navigate('/collections')
   }>{buttonText ?? 'Back Home'}</Button> 
  { notifyUs && <Button target='_blank' href={`https://wa.me/8619539307?text=${messageError}`} type="primary">Notify Us</Button>}</> : undefined}
/>
  )
  };

// const CollectionCard = (props: any)=>{

//   const {collectionTitle, collectionDescription, imgUrl, textsNum, imagesNum, linksNum, status, setOpen, setEdit, id, url, visibility, setPrevUrl} = props;
//   const dispatch = useDispatch<any>();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const {drawer,editId} = useParams();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const handleEdit =()=>{
//     dispatch(changeCreateSuccess(false))
//     dispatch(changeEditSuccess(false))
//     setPrevUrl(location.pathname)
//     navigate(`/dashboard/collections/edit/${id}`)
//     // console.log('edit click')
//     setEdit(true)
//     setOpen(true)
//   }

//   useEffect(()=>{
//     if(drawer === 'edit' && (id == editId)){
//       dispatch(fetchUserItems(editId));
//     }
//   }, [editId])

//   const handleView =()=>{
//     if(status === 'trash'){
//       notification.info({
//         message: `Notification`,
//         description: "Trash Collection can't open!! Change the status of the collection.",
//         placement: 'top'
//       });
//     }
//     else if (status === 'draft'){
//       notification.info({
//         message: `Notification`,
//         description: "Draft Collection can't open!! Change the status of the collection.",
//         placement: 'top'
//       });
//     }
//     else{
//       // navigate(`/collection/preview/${id}`)
//       window.open(`/dashboard/collection/preview/${id}`,'_blank');
//     }
//   }


//   return(
//     <Card className={styles.collectionsCard}>
//       <Row>
//       {/* <Col className={styles.collectionsCardImage} span={2}>
//       <Image
//     width={50}
//     preview={false}
//     style={{borderRadius: "50%"}}
//     src={imgUrl}
//   />
//       </Col> */}
      
//       <Col className={styles.visibilityIcon} span={1}>
//         { visibility === 'public' ? 
//       <GlobalOutlined style={{opacity: "0.7"}} />
//       :
//       <LockOutlined style={{opacity: "0.7"}} />
//     }
//       </Col>
//       <Col className={styles.collectionsCardTitle} span={9}>
//         <Text strong style={{display: "block"}}>{collectionTitle?.length > 60 ? collectionTitle?.slice(0, 60) + ".." : collectionTitle}</Text>
//         <Paragraph style={{margin: "0", color: "grey", fontSize: "13px"}}>{collectionDescription?.length > 70 ? collectionDescription?.slice(0, 70) + ".." : collectionDescription}</Paragraph>
//       </Col>
//       <Col className={styles.collectionCardStats} span={2}>
//         <Text strong>{textsNum}</Text>
//       </Col>
//       <Col className={styles.collectionCardStats} span={2}>
//       <Text strong>{imagesNum}</Text>
//       </Col>
//       <Col className={styles.collectionCardStats} span={2}>
//         <Text strong>{linksNum}</Text>
//       </Col>
//       <Col  className={styles.collectionCardStats} span={4}>
//         {/* <Text strong>{(status === 'publish') ? 'Published' :
//             (status === 'draft') ? 'Draft' :
//             (status === 'trash') ? 'Trash' :
//             'Other'}</Text> */}
//             <Tag style={{margin: "0", fontSize: "13px"}} color={(status === 'publish') ? 'success' :
//             (status === 'draft') ? 'warning' :
//             (status === 'trash') ? 'error' :
//             'Other'}>{(status === 'publish') ? 'Published' :
//             (status === 'draft') ? 'Draft' :
//             (status === 'trash') ? 'Trash' :
//             'Other'}</Tag>
//       </Col>
//       <Col style={{display: "flex"}} span={4}>
//       <Col className={styles.collectionCardIcons} span={8}>
//       <Tooltip placement="top" title={"Edit"}>
//       <EditOutlined onClick={handleEdit} />
//       </Tooltip>
//       </Col>
//       <Col className={styles.collectionCardIcons} span={8}>
//       <Tooltip placement="top" title={"Delete"}>
//       <Popconfirm
//     title={searchParams.get('status') === 'trash' ? "Delete Collection Permanently" : "Move to Trash" }
//     onConfirm={()=> {dispatch(deleteUserCollection({id: id, isPermanent : (status === 'trash') ? true : false})); 
//     dispatch(changeDeleteSuccess(false))}}
//     description={searchParams.get('status') === 'trash' ? "Are you sure to delete this collection permanently" : "Are you sure to delete this task?"}
//     icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
//   >
//     <DeleteOutlined style={{color: "red"}} />
//   </Popconfirm>
//       </Tooltip>
//       </Col>
//       <Col className={styles.collectionCardIcons} span={8}>
//       <Tooltip placement="top" title={"View"}>
//       {/* <Link to={url} target='_blank'> */}
//         <EyeOutlined onClick={handleView} />
//         {/* </Link> */}
//       </Tooltip>
//       </Col>
//       </Col>
//       </Row>
//   </Card>
//   )
// }

const ActivityCard = (props:any) => {

  return(
    <Card className={styles.activityItem}>
            <Badge dot={true}>
                <Row align={"middle"}>
                <Col xs={3} sm={2} md={2} lg={1}>
                <Image preview={false} style={{borderRadius: "50%"}} width={30} src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" />
                </Col>
                <Col style={{paddingLeft: "10px"}} xs={19} sm={20} md={20} lg={21}>
                  {/* <Text className={styles.activityTitle} strong>New Like</Text> */}
                <Text className={styles.activityUsername} strong>@username3242</Text> <Text className={styles.activityDescription}>commented on your collection</Text>  <Text className={styles.activityCollection} strong>PYTHON TUTORIALS</Text></Col>
                <Col style={{textAlign: "right"}} xs={2} sm={2} md={2} lg={2}><Text className={styles.activityTime}>2w</Text></Col>
                </Row>
            </Badge>
            </Card>
  )
}

const TextItem = (props:any) => {

  const {title, description} = props;
  return(
    <>
      <Col>
      <Title className={styles.textItemTitle}  level={5}>{title}</Title>
        <Paragraph>{parse(description ?? '')}</Paragraph>
      </Col>
    </>
  )
}

const ImageItem = (props:any) => {

  const {title, description, url} = props;

  return(
    <>
      <Col>
      <Title className={styles.imageItemTitle}  level={5}>{title}</Title>
      <Image
  //  height={300}
    preview={false}
    width={'100%'}
    src={url}
  />
        <Paragraph style={{ marginTop: "10px" }}>{parse(description ?? '')}</Paragraph>
      </Col>
    </>
  )
}

const LinkItem = (props:any) => {

  const {title, description, url} = props;
  return(
    <>
      <Col>
      <Title className={styles.linkItemTitle}  level={5}>{title}</Title>
      <a style={{wordBreak: "break-all"}} href={url} target="_blank">
      {url}
    </a>
        <Paragraph style={{ marginTop: "10px" }}>{parse(description ?? '')}</Paragraph>
      </Col>
    </>
  )
}


const AuthorCard2 = (props:any) => {

  const {authorName, authorBio, authorImg, username, authorId} = props;
  const navigate = useNavigate();
  const dispatch:any = useDispatch();

  const navigateAuthorPage =()=>{
    dispatch(setWindowNHQ({id : authorId, type : 'author', slug : username}))
    // navigate(`/author/${username}`)
  }


  return(
    <>
      <Col style={{margin: "80px 0 80px 0"}}>
      <Title level={5} style={{marginBottom: "20px"}}>Created by</Title>
      <Avatar onClick={()=> {dispatch(setWindowNHQ({id : authorId, type : 'author', slug : username})); navigate(`/author/${username}`)}} style={{cursor: "pointer"}} src={authorImg} size={60}></Avatar>
      <Title onClick={()=> {dispatch(setWindowNHQ({id : authorId, type : 'author', slug : username}));navigate(`/author/${username}`)} } style={{margin: "10px 0 5px 0", cursor: "pointer"}} level={3}>{authorName}</Title>
      <Paragraph  ellipsis={{symbol: "...", rows: 2, expandable: false, }} className={styles.authorCard2Bio} >{parseHTML(authorBio)}</Paragraph>
      <Link onClick={navigateAuthorPage} to={`/author/${username}`}>View Profile</Link>
      </Col>
    </>
  )
}
const AuthorCard1 = (props:any) => {

  const {authorName, publishDate, authorImg, username, authorId} = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateAuthorPage =()=>{
    dispatch(setWindowNHQ({id : authorId, type : 'author', slug : username}))
    navigate(`/author/${username}`)
  }

  return(
    <>
    <Row style={{marginBottom: "10px"}} align={'middle'}>
       <Col  xs={5} sm={3} md={4} lg={3} xl={2}>
    <Avatar style={{cursor: "pointer"}}  onClick={navigateAuthorPage} src={authorImg} size={50}></Avatar>
    </Col>
    <Col style={{margin: "10px 0"}} xs={19} sm={21} md={20} lg={21} xl={22}>
    <Title  onClick={navigateAuthorPage}style={{margin: "0", cursor: "pointer"}} level={5}>{authorName}</Title>
    <Text>{publishDate}</Text>
    </Col>
    </Row>
    </>
  )
}

const RecommendationCard = (props:any) => {

  const {title, description, likes, dislikes, authorName, authorImg, publishDate, featureImg, key, url, slug, id} = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return(
    <>
    <Col onClick={()=> { dispatch(setWindowNHQ({id : id, type : 'collection', slug : slug})); navigate(`/collection/${slug}`)}}  key={key} xs={24} sm={24} md={12}>
       <Card
       hoverable
    className={styles.recommendationCard}
    cover={
      <Col>
      <img
      style={{width: "100%", maxHeight: "250px", objectFit: "cover", minHeight: "250px", padding: "14px"}}
        alt="example"
        src={featureImg ?? "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"}
      />
      <Row justify={'space-between'} style={{padding: '0 14px'}}>
      <Row >
      {/* <LikeOutlined /> */}
      <Text style={{margin: "5px 0", fontSize: "12px", color: "#878787"}}>{likes-dislikes} Votes</Text>
      </Row>
      <Text style={{margin: "5px 0", fontSize: "12px", fontWeight: "500", color: "#878787"}}>{publishDate ?? 'N/A'}</Text>
      </Row>
      <Row  style={{padding: '0 14px'}} align={'middle'}>
       {/* <Col span={24}> */}
    <Avatar style={{marginRight: "8px"}} src={authorImg} size={30}>New</Avatar>
    {/* </Col> */}
    {/* <Col style={{margin: "10px 0"}} span={20}> */}
    <Title style={{margin: "0", fontSize: "14px"}} level={5}>{authorName?? 'Unknown Author'}</Title>
    {/* <Text style={{fontSize: "11px"}}>{publishDate ?? '19 March 2020'}</Text> */}
    {/* </Col>  */}
    </Row>
</Col>
    }
    // actions={[
    //   <SettingOutlined key="setting" />,
    //   <EditOutlined key="edit" />,
    //   <EllipsisOutlined key="ellipsis" />,
    // ]}
  >
    <Meta
      // avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />}
      title={title}
      description={description?.length > 70 ? description?.slice(0, 70) + ".." : description}
    />
  </Card>
  </Col>
    </>
  )
}
const MoreFromAuthorCard = (props:any) => {

  const {title, description, likes, dislikes, publishDate, featureImg, key, url, isSlider, loading, slug, id, featured, dataLength} = props;
  const navigate = useNavigate();
  const windowNHQ = useSelector((state:any)=> state.windowNHQ?.data)
  const dispatch :any= useDispatch();



  return(
    <>
    {/* <Col span={12}> */}
    <Card
    key={key}
    loading={loading}
    onClick={()=> {dispatch(setWindowNHQ({'id' : id,  type : 'collection', slug : slug})) ; navigate(`/collection/${slug}`)}} 
    className={styles.moreFromAuthorCard}
    // style={isSlider ? {maxWidth: "100%", minWidth: "0px"} : (featured ? {maxWidth : "100%" , minWidth: "0" } : {maxWidth: "260px", minWidth: "0px"})}
    style={featured || isSlider ? (dataLength == 1  ? {maxWidth: "260px", minWidth: "0px"} : {maxWidth : "100%", minWidth: "0px"}) : {maxWidth: "260px", minWidth: "0px"} }
    size= { window.innerWidth < 576 ? 'default' : 'small'}
    cover={
      <Col>
      { featureImg &&
      <img
      style={{width: "100%", maxHeight: "150px", objectFit: "cover", minHeight: "150px"}}
        alt="example"
        src={featureImg}
      />
        }
        { likes && 
        <Row justify={'space-between'} style={{padding: '0 12px'}}>
      <Row >
      {/* <LikeOutlined /> */}
      
      <Text style={{margin: "0 0 0 5px", fontSize: "13px", color: "#878787"}}>{likes-dislikes} Votes</Text>
      </Row>
      <Text  style={{margin: 0, fontSize: "13px", color: "#878787"}}>{publishDate}</Text>
      </Row>
    }
</Col>
    }
    // actions={[
    //   <SettingOutlined key="setting" />,
    //   <EditOutlined key="edit" />,
    //   <EllipsisOutlined key="ellipsis" />,
    // ]}
  >
    <Skeleton loading={loading}>
    <Meta
      // avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />}
      title={title}
      description={description?.length > 70 ? description.slice(0, 70) + ".." : description}
    />
    </Skeleton>
  </Card>
  {/* </Col> */}
    </>
  )
}

const UserActionsBar = (props:any) => {

  const {isLogin, userInteractionProcessing } :any = useSelector((state:any) => state.userActions)
  const dispatch:any = useDispatch();
  const{likes, dislikes, id, liked, disliked, bookmarked, votes} = props;
  const [isBookmark, setIsBookmark] = useState<any>();
  const [openBookmark, setOpenBookmark] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [loginModal, setLoginModal] = useState(false);

  const currentUrl = window.location.href;

  const handlelogin = ()=>{
    setOpenDropdown(false);
    setLoginModal(true);
    }


    useEffect(()=>{
      
      if(Array.isArray(bookmarked)){
        if(bookmarked.includes('B') &&  bookmarked.includes('F')){
          setIsBookmark(['B','F'])
        }
        else if (bookmarked.includes('B') && !bookmarked.includes('F')){
          setIsBookmark(['B'])
        }
        else if (!bookmarked.includes('B') && bookmarked.includes('F')){
          setIsBookmark(['F'])
        }
      }
      else{
        setIsBookmark([])
      }
    }, [bookmarked])


  const handleBookmark =()=>{
    isLogin &&
    setOpenBookmark(true)
  }


  const onLoginCancel = ()=>{
    setLoginModal(false);
  }


  const saveOptions = [
    { label: 'Bookmark', value: 'B' },
    { label: 'Favorites', value: 'F' },
  ];

  const handleSave = (checkedValues:any) => {
    // setIsBookmark(checkedValues);
    dispatch(setUserInteractionProcessing(true))
    dispatch(addBookmark({id: id, type: checkedValues}))


    if (checkedValues.length === 0){
      dispatch(removeBookmarkLocal(id))
    }
    else {
    dispatch(updateBookmarkLocal({id, checkedValues}))
    }
    // checkedValues.length === 0 ? setIsBookmark(false) : setIsBookmark(true)
    dispatch(refreshCard(''))
    dispatch(setAdditionalKeys())
  };

  const saveContent = (
    <Col span={24}>
      <Checkbox.Group style={{display: "flex", flexDirection: "column"}} value={isBookmark} defaultValue={isBookmark} options={saveOptions} onChange={handleSave}  />
    </Col>
  )

  const handlePopoverOutsideClick = (visible:any) => {
    isLogin && setOpenBookmark(visible)
  };
  
  return(
    <>
  <Row style={{margin: "20px 0"}} justify={'space-between'}>
    <Col style={{display:"flex",flexDirection: "row", justifyContent: "space-between"}} xs={5} sm={4} md={4} lg={3} xl={2} >
      {liked ?
    <LikeFilled onClick={()=> isLogin ? (userInteractionProcessing ?   message.warning("Please wait for a moment..") : dispatch(handleLike(id))): handlelogin()} className={styles.UserActionsBarIcon} /> :
    <LikeOutlined onClick={()=> isLogin ? (userInteractionProcessing ?   message.warning("Please wait for a moment..") : dispatch(handleLike(id))): handlelogin()} className={styles.UserActionsBarIcon} />}
      <Text className={styles.UserActionsBarIcon}>{votes ?? likes-dislikes}</Text>
      { disliked ?
      <DislikeFilled onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleDislike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} className={styles.UserActionsBarIcon} /> :
      <DislikeOutlined onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleDislike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} className={styles.UserActionsBarIcon} />}
      {/* <Text className={styles.UserActionsBarIcon}>{dislikes}</Text> */}
    </Col>
    {/* <Col xs={12} md={18} xxl={20}>
    </Col> */}

    <Col style={{display:"flex",flexDirection: "row", justifyContent: "end"}} xs={19} sm={20} md={20} lg={21} xl={22}>
    {/* <SaveOutlined className={styles.UserActionsBarIcon} />
    <ShareAltOutlined className={styles.UserActionsBarIcon} />
      <HeartOutlined className={styles.UserActionsBarIcon} /> */}

<Tooltip overlayInnerStyle={{fontSize: "12px"}} title="Save" color={'blue'} key={"save"}>
                <Popover className={styles.triggerMenuPopover} onOpenChange={handlePopoverOutsideClick} open={openBookmark} trigger={'click'} placement="right" title={'Save in'} content={saveContent}>
                  {isBookmark?.length !== 0  ? 
                <Image
                preview={false}
                className={` ${styles.cardTopIcon}`}
                onClick={isLogin ? handleBookmark : handlelogin} width={20} src={SaveIcon}/>
                 :
                <Image
                preview={false}
                className={` ${styles.cardTopIcon}`}
                onClick={isLogin ? handleBookmark : handlelogin} width={20} src={SaveIconFilled}/>}
                </Popover> 
                </Tooltip>
    </Col>
    
  </Row>
  
  <LoginModal redirectUrl={currentUrl} open={loginModal} onCancel={onLoginCancel}/>

    </>
    
  )
}

const SinglePageTags = (props:any) => {

  const {tags} = props;

  return(
    <>
  {tags?.map((e:any)=>(
    <Tag key={e.slug} color="default">{e.slug}</Tag>

  ))}
    </>
  )
}

const TopCollectionsCard:any = (props: Props) =>{
  const {xs, sm, md, lg, xl, xxl} = props;

  return(
    <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} xxl={xxl}>
    <Card
    hoverable
    style={{ width: "100%" }}
    cover={
      <img
        alt="example"
        src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      />
    }
    // actions={[
    //   <SettingOutlined key="setting" />,
    //   <EditOutlined key="edit" />,
    //   <EllipsisOutlined key="ellipsis" />,
    // ]}
  >
    <Meta
      // avatar={<Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />}
      title="Card title"
      description="This is the description"
    />
  </Card>
  </Col>
  )
}

const FeaturedCollectionCard:any =(props: Props) => {
  const {data, loading} = props;
  const {likes, dislikes, description} = data?.details || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();


  return (
    <>
    {/* <Badge.Ribbon placement='end' style={{display: "flex", flexDirection: "row"}} color='red' text="20 Votes"> */}
    <Skeleton loading={loading} avatar>
    <Row onClick={()=> { dispatch(setWindowNHQ({id : data?.id, type : 'collection', slug : data?.slug}));  navigate(`/collection/${data?.slug}`)}}   className={styles.featuredCollectionMain}>
      <Col className={styles.featuredCollectionImageMain} xs={24} sm={8} md={10}>
      <Image className={styles.featuredCollectionImage} preview={false} height={'100%'} width={'100%'}  src={data?.thumbnail}/>
      <Row align={'middle'} justify={'space-between'} className={styles.overlay}>
        <Text className={styles.text}>{likes-dislikes} Votes</Text>
        <Text className={styles.text}>{data?.publish_date}</Text>
    </Row>
      </Col>
      <Col className={styles.featuredCollectionTextMain} xs={24} sm={16} md={14}>
       <Title className={styles.featuredCollectionTitle} level={3}>{data?.title}</Title>
       {/* <Text className={styles.featuredCollectionStats}>Text: 34 | Images : 2 | Links : 1</Text> */}
       <Paragraph ellipsis={{symbol: "Read more", rows: 2, expandable: false}} className={styles.featuredCollectionDescription}>{description}</Paragraph>
       {/* {!true ? null : ( */}
                <Col span={24}>
                  {data?.tags.map((e: any) => (
                    <BadgeIcon
                      key={e.id}
                      color={"#155ca2"}
                      bgColor={ "#edf5fd"}
                      label={e.slug}
                      />
                   ))} 
                </Col>
      </Col>
    </Row>
    </Skeleton>
{/* </Badge.Ribbon> */}
    </>
  )
}



export {
    // StatisticCard,
    // TopCollectionsCard,
    // TopContributionsCard,
    // Tabs,
    // PaginationBar,
    // CollectionCard,
    // ActivityCard,
    ErrorPage,
    TextItem,
    ImageItem,
    LinkItem,
    AuthorCard2,
    AuthorCard1,
    RecommendationCard,
    MoreFromAuthorCard,
    UserActionsBar,
    SinglePageTags,
    TopCollectionsCard,
    FeaturedCollectionCard
}
